// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}

.info {
  padding: 20px;
}
.info .title {
  text-align: center;
  text-transform: uppercase;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-primary);
}
.info .desc {
  text-align: center;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFontNormal, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: #1a1a18;
}
.info .additional-info {
  margin-top: 15px;
  margin-bottom: 20px;
  padding: 12px;
  background: #f8f8f8;
  border-radius: 8px;
}
.info .additional-info .info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #1a1a18;
}
.info .additional-info .info-item:last-child {
  margin-bottom: 0;
}
.info .additional-info .info-item strong {
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-primary);
}
.info .additional-info .info-item span {
  font-family: AppFontNormal, sans-serif;
  text-align: right;
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

swiper-container {
  height: 100% !important;
  width: 100%;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted.svg') no-repeat center center/100% 130%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background: black url('background.png') no-repeat center center/100% 100% !important;
  background-size: cover;
}

.button-footer-block {
  flex-wrap: wrap;
  background: white;
  justify-content: center;
  margin: 0px !important;
  padding: 0 15px 15px 15px;
  width: 100%;
  z-index: 999;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  display: flex;
  font-size: 16px;
}
.button-footer-block ion-button {
  --padding-start: 24px;
  --padding-end: 7px;
  width: max-content;
  max-width: max-content;
  margin-left: 10px;
  margin-top: 15px;
  flex-grow: 1;
}
@media (max-width: 992px) {
  .button-footer-block ion-button {
    font-size: 14px;
  }
  .button-footer-block ion-button .button-price {
    font-size: 14px;
  }
}
.button-footer-block ion-button.one-button {
  width: 100%;
}
@media (max-width: 992px) {
  .button-footer-block ion-button:last-child {
    width: 35%;
  }
  .button-footer-block ion-button:last-child .buuton-text {
    font-size: 14px;
  }
}
.button-footer-block .buy_without_options {
  width: max-content;
  flex-grow: 12;
  --padding-start: 20px;
  --padding-end: 20px;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  width: 100%;
}

.cursor-pointer {
  cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-info-modal/product-info-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AADD;;AAIA;EACC,aAAA;AADD;AAEC;EACC,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;AAAF;AAGC;EACC,kBAAA;EACA,2CAAA;EACA,sCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,cAAA;AAFF;AAKC;EACC,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAKE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAHH;AAKG;EACC,gBAAA;AAHJ;AAMG;EACC,oCAAA;EACA,+BAAA;AAJJ;AAOG;EACC,sCAAA;EACA,iBAAA;AALJ;;AAWA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,qBAAA;AAbD;AAQC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;AANF;;AAYA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AATD;AAUC;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AARF;AAWC;EACC,YAAA;EACA,eAAA;AATF;;AAaA;EACC,uBAAA;EACA,WAAA;AAVD;;AAaA;EACC,uBAAA;AAVD;;AAYA;EACC,YAAA;EACA,WAAA;AATD;;AAWA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AARD;ACvGE;ED4GF;IAKE,wEAAA;EANA;AACF;AAME;EANF;IAOG,YAAA;EAHD;AACF;;AAMA;EACC,gBAAA;AAHD;AAIC;EACC,WAAA;AAFF;;AAKA;EACC,iBAAA;AAFD;;AAIA;EACC,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AADD;;AAGA;EACC,oFAAA;EACA,sBAAA;AAAD;;AAEA;EACC,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,aAAA;EACA,eAAA;AACD;AAAC;EACC,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAEF;AC1JE;EDiJD;IAUE,eAAA;EAGD;EADC;IACC,eAAA;EAGF;AACF;AAAE;EACC,WAAA;AAEH;ACrKE;EDsKA;IAEE,UAAA;EACF;EAAE;IACC,eAAA;EAEH;AACF;AAEC;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAAF;;AAIA;EACC,YAAA;EACA,gBAAA;EACA,WAAA;AADD;;AAKA;EACC,0BAAA;AAFD","sourcesContent":["@import '../../../theme/mixins';\n\n.option-group-col {\n\tflex-grow: 1;\n\toverflow: auto;\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tpadding: 15px 20px;\n}\n\n.info {\n\tpadding: 20px;\n\t.title {\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 25px;\n\t\tline-height: var(--modal-info-title-line-height);\n\t\tmargin-bottom: 6px;\n\t\tpadding-top: 10px;\n\t\tcolor: var(--ion-color-primary);\n\t}\n\n\t.desc {\n\t\ttext-align: center;\n\t\tfont-size: var(--modal-info-desc-font-size);\n\t\tfont-family: AppFontNormal, sans-serif;\n\n\t\tline-height: var(--modal-info-desc-line-height);\n\t\tpadding-bottom: 10px;\n\t\tcolor: #1a1a18;\n\t}\n\n\t.additional-info {\n\t\tmargin-top: 15px;\n\t\tmargin-bottom: 20px;\n\t\tpadding: 12px;\n\t\tbackground: #f8f8f8;\n\t\tborder-radius: 8px;\n\n\t\t.info-item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: 8px;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #1a1a18;\n\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\n\t\t\tstrong {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontNormal, sans-serif;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.menge {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\th5 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 18px;\n\t\ttext-transform: uppercase;\n\t}\n\tmargin: 0px 20px 20px;\n}\n\n\nion-toolbar {\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\t--background: var(--background-color);\n\tion-title {\n\t\tfont-weight: 100;\n\t\tpadding-inline: unset !important;\n\t\tfont-size: 16px;\n\t\ttext-align: left;\n\t\tmargin-left: 40px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\n\tion-icon {\n\t\tpadding: 8px;\n\t\tfont-size: 15px;\n\t}\n}\n\nswiper-container {\n\theight: 100% !important;\n\twidth: 100%;\n}\n\nion-page {\n\tbackground: transparent;\n}\n.slider-select-half {\n\theight: 100%;\n\twidth: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n\tmargin: 5px 20px;\n\tapp-accordion-list {\n\t\twidth: 100%;\n\t}\n}\n.padding-block {\n\tpadding: 0px 20px;\n}\n.vertical-line {\n\tcontent: ' ';\n\twidth: 1px;\n\theight: 20px;\n\tcolor: white;\n\tbackground: white;\n\tmargin-inline: 10px;\n}\n.add-background {\n\tbackground: black url(../../../assets/background/background.png) no-repeat center center / 100% 100% !important;\n\tbackground-size: cover;\n}\n.button-footer-block {\n\tflex-wrap: wrap;\n\tbackground: white;\n\tjustify-content: center;\n\tmargin: 0px !important;\n\tpadding: 0 15px 15px 15px;\n\twidth: 100%;\n\tz-index: 999;\n\tbox-shadow: 0px -4px 50px 0px #0000001a;\n\tdisplay: flex;\n\tfont-size: 16px;\n\tion-button {\n\t\t--padding-start: 24px;\n\t\t--padding-end: 7px;\n\t\twidth: max-content;\n\t\tmax-width: max-content;\n\t\tmargin-left: 10px;\n\t\tmargin-top: 15px;\n\t\tflex-grow: 1;\n\n\t\t@include mobile {\n\t\t\tfont-size: 14px;\n\n\t\t\t.button-price {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\n\t\t&.one-button {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&:last-child {\n\t\t\t@include mobile {\n\t\t\t\twidth: 35%;\n\t\t\t\t.buuton-text {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.buy_without_options {\n\t\twidth: max-content;\n\t\tflex-grow: 12;\n\t\t--padding-start: 20px;\n\t\t--padding-end: 20px;\n\t}\n}\n\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\twidth: 100%;\n}\n\n\n.cursor-pointer {\n\tcursor: pointer !important;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
